import { Pipe, PipeTransform } from '@angular/core';

/**
 * from:
 *  9994852360
 * to:
 *  (999) 485-2360
 */
@Pipe({
  name: 'phoneNumber',
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string) {
    if (value.length === 10) {
      return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
    }
    return value;
  }
}
